import React, { Component } from 'react';
import { View, Text } from 'react-native';
import { SForm, SNavigation, SPage, SPopup, SText, STheme, SView, Upload } from 'servisofts-component';
import ActionMusculo from './ActionMusculo';
import Container from '../../../../Components/Container';
import SSocket from 'servisofts-socket';
import lista from "./lista"
export default class Crear extends Component {

    static open({ data }) {
        SPopup.open({
            key: "popup_crear_musculo",
            content: <SView backgroundColor={STheme.color.background} style={{ borderRadius: 8, maxWidth: 300 }} padding={16} withoutFeedback col={"xs-11"}>
                <Crear popup data={data} />
            </SView>
        })
    }

    renderForm() {
        return <SForm
            ref={(ref) => this.form = ref}
            inputs={{
                "foto": {
                    label: "Foto", isRequired: true, type: "image",

                    defaultValue: this.props?.data?.key ? SSocket.api.root + "tutorial_musculo/" + this.props?.data?.key : ""
                },
                "descripcion": {
                    label: "Nombre del musculo", isRequired: true, type: "text",
                    defaultValue: this.props?.data?.descripcion,
                },
                "index": {
                    label: "Index", isRequired: false, type: "number", defaultValue: this.props?.data?.index
                }

            }}
            onSubmit={(values) => {
                if (this.props.data) {
                    ActionMusculo.editar({
                        ...this.props.data,
                        descripcion: values.descripcion,
                        index: values.index
                    }).then(async (resp) => {
                        if (this.form) {
                            const files = this.form.getFiles().foto;
                            if (Array.isArray(files)) {
                                console.log("files", files);
                                await Upload.sendPromise({ file: files[0].file }, SSocket.api.root + "upload/tutorial_musculo/" + resp?.key);
                            }
                        }
                        if (this.props.popup) {
                            SPopup.close("popup_crear_musculo");
                        } else {
                            SNavigation.goBack();
                        }
                        if (lista.INSTANCE) lista.INSTANCE.componentDidMount();
                    }).catch((e) => {
                        console.log("error", e);
                    })
                } else {
                    ActionMusculo.crear({
                        descripcion: values.descripcion,
                        index: values.index
                    }).then(async (resp) => {
                        if (this.form) {
                            const files = this.form.getFiles().foto;
                            console.log("files", files);
                            await Upload.sendPromise({ file: files[0].file }, SSocket.api.root + "upload/tutorial_musculo/" + resp?.key);
                        }
                        if (this.props.popup) {
                            SPopup.close("popup_crear_musculo");
                        } else {
                            SNavigation.goBack();
                        }


                        if (lista.INSTANCE) lista.INSTANCE.componentDidMount();
                    }).catch((e) => {
                        console.log("error", e);
                    })
                }

            }}
            onSubmitName={"Guardar"}
        />
    }

    render() {
        if (this.props.popup) {
            return <SView col={"xs-12"} center>
                <SText>{"Crear Musculo"}</SText>
                {this.renderForm()}
            </SView>
        }
        return <SPage title={"Crear Musculo"} {...this.props.page}>
            <Container>
                {this.renderForm()}
            </Container>
        </SPage>
    }
}
